module.exports = __webpack_public_path__ + "img/bottom_icon02.407f88d.png";